import React, { useEffect, useReducer, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import DashboardContainer from "../../components/dashboard-container";
import NotificationList from "../../components/notification-list";
import buildQuery from "../../utils/query-builder";
import { notificationService } from "../../utils/services/notificationService";
import "react-quill/dist/quill.snow.css";
import { notificationInitialState } from "../../utils/filter-config";
import { EmailSendingLoader } from "../../components/continuous-progress-loader";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    case "INIT":
      return {
        ...state,
        columns: state.columns.map((x) => {
          if (x.key === "createdAt") x.sort = -1;
          return x;
        }),
      };
    default:
      return state;
  }
}

const AlertAndNotification = () => {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    notificationInitialState
  );
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = React.useState(0);
  const [dataCount, setDataCount] = useState(15);
  const [loading, setLoading] = useState(false);
  const [fetchData, setFetchData] = useState(0);
  const client_id = localStorage.getItem("client_id");
  const [selectedItems, setSelectedItems] = useState([]);
  const [notifyLoader, setNotifyLoader] = useState(false);

  useEffect(() => {
    dispatch({ type: "INIT" });
  }, []);

  const fetchNotifications = async (signal) => {
    setLoading(true);
    try {
      const response = await notificationService.fetch(
        client_id,
        buildQuery(filterData, page),
        { signal }
      );

      setNotifications(response.data);
      setDataCount(response?.total || 0);
    } catch (error) {
      console.error("Fetch failed:", error);
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchNotifications(signal);
    return () => {
      controller.abort();
    };
  }, [page, filterData, fetchData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        filterData={filterData}
        fields={filterData.columns}
        header={"Notifications"}
        hideUploadButton
        hideAddButton
        onClickRefresh={() => setFetchData((prev) => prev + 1)}
        manifest
        hideFilterClient
      >
        {notifyLoader && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <EmailSendingLoader />
          </Box>
        )}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <NotificationList
            setNotifyLoader={setNotifyLoader}
            notifyLoader={notifyLoader}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            dataCount={dataCount}
            page={page}
            rowsPerPage={filterData.limit}
            setRowsPerPage={(e) =>
              dispatch({
                type: "UPDATE_LIMIT",
                payload: e,
              })
            }
            setPage={setPage}
            data={notifications}
            setData={setNotifications}
            onChangeFilter={handleFilterChange}
            filterData={filterData}
            fetchNotifications={fetchNotifications}
            client_id={client_id}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default AlertAndNotification;
